// extracted by mini-css-extract-plugin
export default {"stop":"RouteDetails_stop__TZAdS","stopLocation":"RouteDetails_stopLocation__l0Swd","travel":"RouteDetails_travel__TeLAy"};